import React from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell } from "@shared/components";
import { AgreementPlan } from "@modules/agreementPlans/types";

export const useAgreementPlansListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  agreement?: AgreementPlan[],
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "name",
        headerName: translate("agreement_plans.fields.name"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "type",
        headerName: translate("agreement_plans.fields.type"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="center"
          />
        ),
      },
      {
        field: "for_agreement",
        headerName: translate("agreement_plans.fields.for_agreement"),
        minWidth: 250,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/agreement/edit/${value}`}
            value={agreement?.find(item => item.id === value)?.name}
          />
        ),
      },
      {
        field: "value",
        headerName: translate("agreement_plans.fields.value"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value ? `R$ ${Number(value).toFixed(2)}` : value}
            textAlign="right"
          />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              recordItemId={row.id}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, agreement],
  );
};
